import { ThirdPartyEvaluationFormItemAnswer } from './thirdparty-evaluation-form-item-answer';
import { ThirdPartyEvaluationFormItemRecordColumn } from './thirdparty-evaluation-form-item-record-columns';

export class ThirdPartyEvaluationFormItem {
    id: number = 0;
    description: string = '';
    itemOrder: number = 0;
    section: string = '';
    code: string = '';
    explanation: string = '';
    defaultAutoevalutedAnswer: number;
    isCommentRequierdInAutoevaluateChange: boolean;
    parentId: number = null;

    itemTypeId: number = 1;
    isRequired: boolean = true;
    isCommentAvailable: boolean = true;
    isFileAvailable: boolean = true;

    appFormItemAnswers: ThirdPartyEvaluationFormItemAnswer[] = [new ThirdPartyEvaluationFormItemAnswer()];

    followUpTaskFormItemAnswers: ThirdPartyEvaluationFormItemAnswer[] = [new ThirdPartyEvaluationFormItemAnswer()];

    recordColumns: ThirdPartyEvaluationFormItemRecordColumn[] = [new ThirdPartyEvaluationFormItemRecordColumn()];

    constructor() {
    }
}